import withApiData from "../withApiData";
import MidFooter from "./MidFooter";
import Placeholder from "./Placeholder";

export default withApiData(MidFooter, Placeholder);
